// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageContentSection_container__5CD5p"};